import { Box, Card, Typography, Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Header } from '../common/Header'
import { RootState, useAppSelector } from '../../store/store'
import { SubscriptionsSection } from './subscriptions/SubscriptionsSection'

export default function Profile() {
    const { t } = useTranslation()
    const { userInfo } = useAppSelector((state: RootState) => state.profile)

    return (
        <Box sx={{ margin: '0 auto' }}>
            <Card elevation={3} sx={{ mb: 1.25, borderRadius: 2 }}>
                <Header title={t('PROFILE_PERSONAL_INFORMATION')} />
                {userInfo && (
                    <Box sx={{ p: 1.25 }}>
                        <Grid container spacing={1.25}>
                            <InfoItem label={t('USER_MANAGEMENT_FIRST_NAME_LABEL')} value={userInfo.firstName} />
                            <InfoItem label={t('USER_MANAGEMENT_LAST_NAME_LABEL')} value={userInfo.lastName} />
                            <InfoItem label={t('USER_MANAGEMENT_COMPANY_NAME_LABEL')} value={userInfo.companyName} />
                            <InfoItem label={t('USER_MANAGEMENT_JOB_TITLE_LABEL')} value={userInfo.jobTitle} />
                            <InfoItem label={t('USER_MANAGEMENT_EMAIL_LABEL')} value={userInfo.email} />
                            <InfoItem label={t('USER_MANAGEMENT_PHONE_NUMBER_LABEL')} value={userInfo.phoneNumber} />
                            <InfoItem label={t('USER_MANAGEMENT_ROLE_LABEL')} value={userInfo.role} />
                        </Grid>
                    </Box>
                )}
            </Card>
            <SubscriptionsSection />
        </Box>
    )
}

interface InfoItemProps {
    label: string
    value?: string | null
}

const InfoItem = ({ label, value }: InfoItemProps) => (
    <Grid item xs={12} sm={6} md={4}>
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 0.25,
                p: 1,
                borderRadius: 1,
                border: 1,
                borderColor: 'divider',
                height: '100%',
            }}
        >
            <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontWeight: 600, letterSpacing: 0.3 }}
            >
                {label}
            </Typography>

            <Typography
                variant="body1"
                sx={{
                    fontWeight: 500,
                    wordBreak: 'break-word',
                }}
            >
                {value ?? '-'}
            </Typography>
        </Box>
    </Grid>
)